import React from 'react';
import { Alert } from '@gjensidige/core-alerts/lib/default';
import { Info } from '@gjensidige/core-icons/lib/info';
import styles from './InfoAlert.module.less';
import { Text } from '@gjensidige/core-typography';
export const AdditionalInfoAlert = ({ text }) => {
    return (React.createElement(Alert, { className: styles.infoAlert, showIcon: false },
        React.createElement("div", { className: styles.icon },
            React.createElement(Info, { color: "#EB9119" })),
        React.createElement(Text, { size: 'small', className: styles.textCenter }, text)));
};
